module.exports = __webpack_public_path__ + "static/media/settings_room_device_speaker.72595e0b.svg";